// for removing antd-vue warnings for modal and drawer
const setupPortal = (el, binding) => {
  const value = binding.value

  const parentNode = typeof value === 'function' ? value(el) : value
  if (parentNode !== el.parentNode) {
    parentNode.appendChild(el)
  }
}

export const antPortal = {
  inserted: setupPortal,
  componentUpdated: setupPortal,
}
